// extracted by mini-css-extract-plugin
export default {"container":"ViewMatchedCondtitions_container__AENYU","scrollable":"ViewMatchedCondtitions_scrollable__JJkNl"};